/**
 * trillSignTableModule
 * description：融合审签-抖音表格组件
 * author：Qian.qianchen
 */
'use strict';
angular.module('trillSignTableModule', ['editTrillPendingModule']).directive('trillSignTable', [
    '$q',
    'trsHttpService',
    'storageListenerService',
    'editingCenterService',
    'newMediaService',
    function ($q, trsHttpService, storageListenerService, editingCenterService, newMediaService) {
        return {
            restrict: 'E',
            replace: false,
            templateUrl: './editingCenter/iWo/fusionSign/directive/trillSignTable/trillSignTable_tpl.html',
            scope: {
                productInfo: '=',
                selectedArray: '=',
                fromDate: '=',
                untilDate: '=',
                channelValue: '=',
                page: '=',
                mediaType: '=',
            },
            link: function ($scope) {
                initStatus();
                initData();
 
                /**
                  * [initStatus description] 状态初始化
                  * @return {[type]} [description]
                  */
                function initStatus() {
                    $scope.status = {
                        DocType: '',
                        mediaType: $scope.mediaType,
                    };
                    $scope.data = {
                        tableData: [],
                    };
                    $scope.$on('refresh', function () {
                        requestData();
                    });
                }
 
                /**
                  * [initData description] 数据初始化
                  * @return {[type]} [description]
                  */
                function initData() {
                    listenStorage();
                    requestData();
                }
 
                /**
                  * [listenStorage description]监听本地缓存
                  * @return {[promise]} [description] promise
                  */
                function listenStorage() {
                    storageListenerService.listenTrill(function () {
                        requestData();
                        storageListenerService.removeListener('trill');
                    }, $scope);
                }
 
                /**
                  * [requestData description] 表格数据请求
                  * @return {[type]} [description]
                  */
                function requestData() {
                    var deffer = $q.defer();
                    var params = {
                        serviceid: 'mlf_fusion',
                        methodname: 'queryFusionDocumentsInShenQian',
                        CurrPage: $scope.page.CURRPAGE,
                        PageSize: $scope.page.PAGESIZE,
                        OprTime: $scope.status.OprTime,
                        OprTimeStart: angular.isDefined($scope.fromDate) ? $scope.fromDate : '',
                        OprTimeEnd: angular.isDefined($scope.untilDate) ? $scope.untilDate : '',
                        MediaTypes: $scope.mediaType,
                        isPass: $scope.$parent.status.isPass,
                        ChannelId: $scope.$parent.data.channelValue
                    };
                    $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function (data) {
                        $scope.data.tableData = data.DATA;
                        $scope.data.items = data.DATA;
                        $scope.data.itemCount = data.PAGER.ITEMCOUNT;
                        $scope.page.PAGESIZE = data.PAGER.PAGESIZE;
                        $scope.page.CURRPAGE = data.PAGER.CURRPAGE;
                        $scope.page.ITEMCOUNT = data.PAGER.ITEMCOUNT;
                        $scope.page.PAGECOUNT = data.PAGER.PAGECOUNT;
                        $scope.selectedArray = [];
                        newMediaService.getReviseInfo($scope.data.items);
                        deffer.resolve(data);
                    });
                    return deffer.promise;
                }
 
                /**
                  * [formatToStringTime 时间戳转换成 YYYY-MM-dd HH:mm:ss]
                  * @param {[type]} timestamp [description]
                  * @return {[type]} [description]
                  */
                function formatToStringTime(timestamp) {
                    let year, month, days, hours, minutes, seconds, result;
                    timestamp = new Date(timestamp);
                    year = timestamp.getFullYear();
                    month = timestamp.getMonth() + 1 < 10 ? '0' + (timestamp.getMonth() + 1) : timestamp.getMonth() + 1;
                    days = timestamp.getDate() < 10 ? '0' + timestamp.getDate() : timestamp.getDate();
                    hours = timestamp.getHours() < 10 ? '0' + timestamp.getHours() : timestamp.getHours();
                    minutes = timestamp.getMinutes() < 10 ? '0' + timestamp.getMinutes() : timestamp.getMinutes();
                    seconds = timestamp.getSeconds() < 10 ? '0' + timestamp.getSeconds() : timestamp.getSeconds();
                    result = year + '-' + month + '-' + days + ' ' + hours + ':' + minutes + ':' + seconds;
                    return result;
                }
 
                /**
                  * [selectItem description] 稿件选择/取消选择
                  * @param  {[type]} item [description] 稿件
                  * @return {[type]}      [description]
                  */
                $scope.selectItem = function (item) {
                    if ($scope.isChecked(item)) {
                        $scope.selectedArray = $scope.selectedArray.filter(function (_item, index) {
                            return item.METADATAID != _item.METADATAID;
                        });
                    } else {
                        $scope.selectedArray.push(item);
                    }
                };
 
                /**
                  * [isChecked description] 判断稿件是否选中
                  * @param  {[type]}  item [description] 稿件
                  * @return {Boolean}      [description]
                  */
                $scope.isChecked = function (item) {
                    return $scope.selectedArray.some(function (_item, index) {
                        return item.METADATAID == _item.METADATAID;
                    });
                };
 
                /**
                  * [selectAll description] 全选/取消全选
                  * @return {[type]} [description]
                  */
                $scope.selectAll = function () {
                    if ($scope.selectedArray.length == $scope.data.tableData.length) {
                        $scope.selectedArray = [];
                    } else {
                        $scope.selectedArray = angular.copy($scope.data.tableData);
                    }
                };
 
                /**
                  * [isSelectTime description] 是否进行了时间筛选
                  * @return {Boolean} [description]
                  */
                $scope.isSelectTime = function () {
                    var res =
                         (angular.isUndefined($scope.fromDate) || $scope.fromDate == '') &&
                         (angular.isUndefined($scope.untilDate) || $scope.untilDate == '');
                    return res;
                };
 
                /**
                  * [showMore description] 加载更多
                  * @return {[type]} [description]
                  */
                $scope.showMore = function () {
                    $scope.status.page.PAGESIZE += 10;
                    requestData();
                };
 
                /**
                  * [loadSpecialData description] 加载特殊时间条件数据
                  * @param  {[type]} oprTime [description] 时间条件（1天/3天）
                  * @return {[type]}         [description]
                  */
                $scope.loadSpecialData = function (oprTime) {
                    var currDate = new Date();
                    var currYear = currDate.getFullYear();
                    var currMonth = currDate.getMonth() < 10 ? '0' + (currDate.getMonth() + 1) : currDate.getMonth() + 1;
                    var currDay = currDate.getDate() < 10 ? '0' + currDate.getDate() : currDate.getDate();
                    var currHour = currDate.getHours() < 10 ? '0' + currDate.getHours() : currDate.getHours();
                    var currMinute = currDate.getMinutes() < 10 ? '0' + currDate.getMinutes() : currDate.getMinutes();
                    var currSecond = currDate.getSeconds() < 10 ? '0' + currDate.getSeconds() : currDate.getSeconds();
                    var startTime = '';
                    var endTime = currYear + '-' + currMonth + '-' + currDay + ' ' + currHour + ':' + currMinute + ':' + currSecond;
                    startTime = formatToStringTime(new Date(endTime) - oprTime * 24 * 60 * 60 * 1000 + 1000);
                    $scope.fromDate = startTime;
                    $scope.untilDate = endTime;
                    requestData(false);
                };
 
                /**
                  * [processRecord description] 获取企鹅号流程记录
                  * @param   {[type]}  item  [item description] 选中的企鹅号稿件
                  * @return  {[type]}        [return description]
                  */
                $scope.processRecord = function (item) {
                    editingCenterService.getVersionTime(item, false);
                };
 
                /**
                  * [trillEditor description]
                  *
                  * @param   {[type]}  account     [account description]
                  * @param   {[type]}  ariticlid   [ariticlid description]
                  * @param   {[type]}  isOriginal  [isOriginal description]
                  * @param   {[type]}  platform    [platform description]
                  *
                  * @return  {[type]}              [return description]
                  */
                $scope.trillEditor = function (item) {
                    let urlParams = {
                        platform: '1',
                    };
                    editingCenterService.routerToEditorWithLock(angular.extend(item, urlParams));
                };
            },
        };
    },
]);
 
